import { toasterMsg } from "../../../../../Components/Toaster/Toaster";
import t from "./Indicator.type";
import { getSampleRequestsTodoListService, getTodolistCountService, exportExcelService, exportToPdfService } from "../../../../../services/todo-list.service";
import { imageUrl } from "../../../../../Components/helper";

export const getIndicatorList = (pramams) => async (dispatch) => {
  try {
    const requestId = pramams.requestId || Date.now().toString();
    const res = await getSampleRequestsTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_INDICATOR_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
          requestId,
        },
      });
      return res.data.doc;
    }
    return res.data;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getIndicatorTodolistCount = (pramams) => async (dispatch) => {
  try {
    const res = await getTodolistCountService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_INDICATOR_TODO_LIST_COUNT,
        payload: {
          totalCount: res.data.totalCount,
          type: pramams.type,
        },
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setSelectedIds = (idsArr) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_PROGRESS_SELECTED_IDS_ARRAY,
      payload: idsArr,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportExcel = (params) => async () => {
  try {
    const res = await exportExcelService(params);
    if (res?.data?.fileName) {
      const fileName = res.data.fileName.toString();
      const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL);
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportToPdf = (params) => async () => {
  try {
    const res = await exportToPdfService(params);
    if (res?.data?.status === 'generating') {
      toasterMsg('Your PDF is being prepared. You will be notified when it is ready to download.', 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
